/**
 * Pinball camera orientation mapping.
 * All screen-space to game-space conversions in one place.
 *
 * Camera looks down at table with positive Z at bottom of screen.
 * This means screen-left maps to game-right and vice versa.
 */
export const PINBALL_ORIENTATION = {
  /** Screen left touch maps to this game flipper */
  screenLeftFlipper: 'right' as const,
  /** Screen right touch maps to this game flipper */
  screenRightFlipper: 'left' as const,
  /** Tilt X sign flip for drag input (-1 = inverted) */
  tiltXSign: -1,
  /** Tilt Z sign for physics (+1 = not inverted) */
  tiltZSign: 1,
};

/** Map screen-space side to game-space flipper side */
export function screenToGameFlipper(screenSide: 'left' | 'right'): 'left' | 'right' {
  return screenSide === 'left'
    ? PINBALL_ORIENTATION.screenLeftFlipper
    : PINBALL_ORIENTATION.screenRightFlipper;
}
